const Divider = ({ className }) => {
  return <div className={`w-full border-b border-gray-culture ${className}`}></div>;
};

export default Divider;
